import { Component, Input, OnInit } from '@angular/core';
import { MediaService } from 'src/app/services/media.service';

@Component({
  selector: 'app-specialisatie-card',
  templateUrl: './specialisatie-card.component.html',
  styleUrls: ['./specialisatie-card.component.sass']
})
export class SpecialisatieCardComponent implements OnInit {

  @Input() spec:any = {};
  target:string | undefined;

  constructor(private mediaService:MediaService) { }

  ngOnInit(): void {
    this.spec.pic = this.mediaService.getMediaItemUrl(this.spec.afbeelding);

    if(this.spec.omschrijving.startsWith("[static-page]")) {
      this.target = this.spec.omschrijving.split("[static-page]")[1];
    } else {
      this.target = "/specialisatie"
    }
  }

}
